import { Injectable } from '@angular/core';

import { doc, docData, collection, collectionData, Firestore, query, orderBy, where, limit, addDoc, updateDoc, deleteDoc, setDoc, deleteField, getDocs, collectionGroup, writeBatch, startAfter, getDocsFromServer, startAt, endAt, getDoc } from '@angular/fire/firestore';

import { TranslateService } from '@ngx-translate/core';

import { map } from 'rxjs/operators';

import { GameTemplate } from '../classes/index';
import { LanguageService } from './language.service';

@Injectable()
export class TemplateService {

	templates;

	constructor(public translate: TranslateService,
		private firestore: Firestore,
		public languageService: LanguageService,) {
			console.log('TemplateService initialization...');
			this.listTemplates()
			//.pipe(take(1))
			.subscribe(templates => {
				this.templates = templates.sort((a, b) => {
					if(a.name[translate.currentLang] && b.name[translate.currentLang]){
						if (a.name[translate.currentLang].toUpperCase() > b.name[translate.currentLang].toUpperCase()) return 1;
						if (a.name[translate.currentLang].toUpperCase() < b.name[translate.currentLang].toUpperCase()) return -1;
					}
					return 0;
				})
			});
	}

	getLocalTemplate(templateId){
		if(this.templates){
			return this.templates.filter(function( template ) {return template.id == templateId})[0];
		}
		return null;
	}

	listTemplates(){
		return collectionData(query(collection(this.firestore, 'game_templates'), orderBy('name.'+this.languageService.currentLang, 'asc')), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(doc => {
				let template = new GameTemplate();
				template.fromJSON(doc);
				return template;
			});
		}));
	}
	listTemplateByEpisode(episodeId){
		return collectionData(query(collection(this.firestore, 'game_templates'), where("episodeId", "==", episodeId)), { idField: 'id' })
		.pipe(map(collection => {
			return collection.map(doc => {
				let template = new GameTemplate();
				template.fromJSON(doc);
				return template;
			});
		}));
	}

	getTemplate(templateUid){
		return docData(doc(this.firestore, `game_templates/${templateUid}`))
		.pipe(map(data => {
			let template = new GameTemplate();
			template.fromJSON(data);
			return template;
		}));
	}

	addTemplate(data) {
		return addDoc(collection(this.firestore, 'game_templates'), {...data});
	}

	updateTemplate(templateUid, data){
		return updateDoc(doc(this.firestore, `game_templates/${templateUid}`), {...data});
	}

	deleteTemplate(templateUid) {
		return deleteDoc(doc(this.firestore, `game_templates/${templateUid}`));
	}

	getDiagram(templateUid){
		return docData(doc(this.firestore, `game_templates/${templateUid}/diagrams/default`));
	}

	setDiagram(templateUid, diagram) {
		return setDoc(doc(this.firestore, `game_templates/${templateUid}/diagrams/default`), diagram);
	}

	getTemplateChecks(){
		return collectionData(query(collection(this.firestore, 'template_checks')), { idField: 'id' });
	}

	updateTemplateCheck(templateUid, data){
		return updateDoc(doc(this.firestore, `template_checks/${templateUid}`), data);
	}

	setTemplateCheck(templateUid, data){
		return setDoc(doc(this.firestore, `template_checks/${templateUid}`), data);
	}

	deleteTemplateCheck(templateUid) {
		return deleteDoc(doc(this.firestore, `template_checks/${templateUid}`));
	}
}
